import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {Space} from '@features/assignment/types.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {raise} from '@utilities/helpers.ts'
import {httpGetSpaces} from '@features/assignment/http/assignment.http'
import {captureException} from '@sentry/react'
import {z} from 'zod'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useGetSpaces = (
    assignmentId?: number,
    options?: Omit<UseQueryOptions<Space[]>, 'queryFn' | 'queryKey'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.SPACES, assignmentId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetSpaces({
                    urlParams: {assignmentId: assignmentId ?? raise('The code is not provided')},
                    params: {response_type: 'extended'}
                }),
                responseShape: z.array(Space),
                onZodError: captureException
            }),
        ...options
    })
}
